import { Component, OnInit, NgZone } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ProfileService } from 'common/services/profile.service';

import { ADPResourceService as ResourceService } from 'digital-core';
import { AuthenticationService } from '../../../services/authentication.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'logout',
  templateUrl: './logOut.component.html',
  styleUrls: ['./logOut.component.css']
})
export class LogOutComponent implements OnInit {

  selectedCategory: string;
  redirectLoginPage: string = "";
  constructor(
    public resourceService: ResourceService,
    public ngZone: NgZone,
    public profileService: ProfileService,
    public domSanitizer: DomSanitizer,
    private authenticationService: AuthenticationService) {
  }

  ngOnInit() {
    this.authenticationService.logOut(true);
  }

}
